import React from 'react'
import Link from 'gatsby-link'

import './services.css'

const Services = () => (
  <div className="Services">
    <div className="services container">
      <div className="row">
        <div className="col-lg-10 offset-lg-1 text-center">
          <h1>Our Services</h1>

          <p>We have experience completing a wide range of projects from big to small. 
            Below we have listed some of the services we offer however this is 
            not an exhaustive list, we can do a lot, lot more!</p>
        </div>
      </div>

      <div className="row text-center" style={{ marginTop: '50px' }}>
        <div className="col-md-6 col-lg-3 service">
          <h3>Home Extensions</h3>

          <div className="img-container plans"></div>

          <p>Whether you are looking to create an open-plan kitchen-diner, or separate 
            additional space to relax with the family, additional bedrooms, a study or a 
            home office – Ridley Owen &amp; Sons are here to help.</p>
        </div>

        <div className="col-md-6 col-lg-3 service">
          <h3>Refurbishment</h3>

          <div className="img-container workers"></div>

          <p>We have extensive experience of all forms of refurbishment from small one 
            bedroom flats to eight bedroom mansions, our portfolio also includes a number
            of office and commercial refurbishments and even Embassy work.</p>
        </div>

        <div className="col-md-6 col-lg-3 service">
          <h3>Maintenance</h3>

          <div className="img-container plumbing"></div>

          <p>We provide reactive and planned maintenance for letting agencies, landlords, 
            residential care homes, and home owners. Through our 
            passion for excellence we are renowned for providing quality, reliability, 
            and craftsmanship.</p>
        </div>

        <div className="col-md-6 col-lg-3 service">
          <h3>Home Improvements</h3>

          <div className="img-container home"></div>

          <p>Our role is to deliver the renovation of your dreams, within your budget. 
            If you want the very best outcome, for the best price, you need our team of 
            renovation specialists on your side.</p>
        </div>
      </div>

    </div>
  </div>
)

export default Services


// WEBPACK FOOTER //
// ./src/components/Services/index.js